import React from 'react';
import {authRole} from '../../shared/constants/AppConst';


export const homeConfig = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/home/dashboard',
        component: React.lazy(() => import('./Dashboard')),
      }
    ],
  },
  {
    auth: authRole.admin,
    routes: [
      {
        path: '/home/memberReports',
        component: React.lazy(() => import('./MemberReports')),
      }
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/home/intake',
        component: React.lazy(() => import('./Intake')),
      }
    ],
  }
];
